import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

export type Meta = {
  title: string;
  authRequired: boolean;
  beforeResolve?: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => void;
};
export default [
  {
    path: '/',
    redirect: { name: 'home' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../pages/login/index.vue'),
    meta: {
      title: 'ログイン',
      authRequired: false,
    },
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      title: 'ホーム',
      authRequired: true,
    },
    component: () => import('../pages/home/index.vue'),
  },
  {
    path: '/user-list',
    name: 'userList',
    meta: {
      title: 'ユーザ一覧',
      authRequired: true,
    },
    component: () => import('../pages/user/list/index.vue'),
  },
  {
    path: '/user-info/:userId',
    name: 'userInfo',
    meta: {
      title: 'ユーザ情報',
      authRequired: true,
    },
    component: () => import('../pages/user/user-info/index.vue'),
  },
  {
    path: '/admin-list',
    name: 'adminList',
    meta: {
      title: '管理者一覧',
      authRequired: true,
    },
    component: () => import('../pages/admin/list/index.vue'),
  },
  {
    path: '/facility-list',
    name: 'facilityList',
    meta: {
      title: '施設一覧',
      authRequired: true,
    },
    component: () => import('../pages/facility/list/index.vue'),
  },
  {
    path: '/facility-info/:facilityId',
    name: 'facilityInfo',
    meta: {
      title: '施設詳細',
      authRequired: true,
    },
    component: () => import('../pages/facility/facility-info/index.vue'),
  },
  {
    path: '/facility-history/:facilityId',
    name: 'facilityHistory',
    meta: {
      title: '施設変更届履歴',
      authRequired: true,
    },
    component: () => import('../pages/facility/facility-history/index.vue'),
  },
  {
    path: '/update-facility-status',
    name: 'updateFacilityStatus',
    meta: {
      title: '認定期間・ステータス更新CSVアップロード',
      authRequired: true,
    },
    component: () => import('../pages/facility/facility-status/index.vue'),
  },
  {
    path: '/payment-count',
    name: 'paymentCount',
    meta: {
      title: '申込者・入金件数確認',
      authRequired: true,
    },
    component: () => import('../pages/payment-count/index.vue'),
  },
  {
    path: '/payment-situation',
    name: 'paymentSituation',
    meta: {
      title: '入金状況一覧',
      authRequired: true,
    },
    component: () => import('../pages/payment-situation/index.vue'),
  },
  {
    path: '/updaters-progress-list',
    name: 'updatersProgressStatusList',
    meta: {
      title: '更新進捗状況一覧',
      authRequired: true,
    },
    component: () => import('../pages/updaters-progress/index.vue'),
  },
  {
    path: '/updaters-target-list',
    name: 'updatersTargetStatusList',
    meta: {
      title: '更新対象者状況一覧',
      authRequired: true,
    },
    component: () => import('../pages/updaters-target/index.vue'),
  },
  {
    path: '/course-list',
    name: 'courseList',
    meta: {
      title: 'コース一覧',
      authRequired: true,
    },
    component: () => import('../pages/e-learning/course/list.vue'),
  },
  {
    path: '/create-course',
    name: 'createCourse',
    meta: {
      title: 'コース作成',
      authRequired: true,
    },
    component: () => import('../pages/e-learning/course/create.vue'),
  },
  {
    path: '/edit-course/:courseId',
    name: 'editCourse',
    meta: {
      title: 'コース編集',
      authRequired: true,
    },
    component: () => import('../pages/e-learning/course/edit.vue'),
  },
  {
    path: '/edit-contents/:courseId',
    name: 'editContents',
    meta: {
      title: 'コンテンツ編集',
      authRequired: true,
    },
    component: () => import('../pages/e-learning/content/index.vue'),
  },
  {
    path: '/content-histories/:courseId',
    name: 'contentHistories',
    meta: {
      title: '受講状況',
      authRequired: true,
    },
    component: () => import('../pages/e-learning/history/index.vue'),
  },
  {
    path: '/user-mail-form',
    name: 'userMailForm',
    meta: {
      title: 'メール送信',
      authRequired: true,
    },
    component: () => import('../pages/user-mail/send-form.vue'),
  },
  {
    path: '/facility-mail-form',
    name: 'facilityMailForm',
    meta: {
      title: '施設メール送信',
      authRequired: true,
    },
    component: () => import('../pages/facility-mail/send-form.vue'),
  },
  {
    path: '/mail-template-list',
    name: 'mailTemplateList',
    meta: {
      title: 'メールテンプレート一覧',
      authRequired: true,
    },
    component: () => import('../pages/mail-template/list/index.vue'),
  },
  {
    path: '/mail-template-detail/:templateId',
    name: 'mailTemplateDetail',
    meta: {
      title: 'メールテンプレート詳細',
      authRequired: true,
    },
    component: () => import('../pages/mail-template/detail/index.vue'),
  },
  {
    path: '/mail-template-register',
    name: 'mailTemplateRegister',
    meta: {
      title: 'メールテンプレート登録',
      authRequired: true,
    },
    component: () => import('../pages/mail-template/register/index.vue'),
  },
  {
    path: '/facility-mail-template-detail/:templateId',
    name: 'facilityMailTemplateDetail',
    meta: {
      title: '施設メールテンプレート詳細',
      authRequired: true,
    },
    component: () => import('../pages/mail-template-facility/detail/index.vue'),
  },
  {
    path: '/facility-mail-template-register',
    name: 'facilityMailTemplateRegister',
    meta: {
      title: '施設メールテンプレート登録',
      authRequired: true,
    },
    component: () => import('../pages/mail-template-facility/detail/index.vue'),
  },
  {
    path: '/facility-mail-template-list',
    name: 'facilityMailTemplateList',
    meta: {
      title: '施設メールテンプレート一覧',
      authRequired: true,
    },
    component: () => import('../pages/mail-template-facility/list/index.vue'),
  },
  {
    path: '/information-list',
    name: 'informationList',
    meta: {
      title: 'インフォメーション一覧',
      authRequired: true,
    },
    component: () => import('../pages/information/list.vue'),
  },
  {
    path: '/register-info',
    name: 'registerInfo',
    meta: {
      title: 'インフォメーション設定',
      authRequired: true,
    },
    component: () => import('../pages/information/register.vue'),
  },
  {
    path: '/edit-info/:informationId',
    name: 'editInfo',
    meta: {
      title: 'インフォメーション設定',
      authRequired: true,
    },
    component: () => import('../pages/information/edit.vue'),
  },
  {
    path: '/period-register',
    name: 'periodRegister',
    meta: {
      title: '期間登録',
      authRequired: true,
    },
    component: () => import('../pages/master/period-register/index.vue'),
  },
  {
    path: '/upload-new-seminar',
    name: 'uploadNewSeminar',
    meta: {
      title: '新規申請用学術集会マスタCSVインポート',
      authRequired: true,
    },
    component: () => import('../pages/master/new-seminar/index.vue'),
  },
  {
    path: '/upload-update-seminar',
    name: 'uploadUpdateSeminar',
    meta: {
      title: '更新申請用学術集会マスタCSVインポート',
      authRequired: true,
    },
    component: () => import('../pages/master/update-seminar/index.vue'),
  },
  {
    path: '/period-register',
    name: 'periodRegister',
    meta: {
      title: '期間登録',
      authRequired: true,
    },
    component: () => import('../pages/master/period-register/index.vue'),
  },
  {
    path: '/upload-cbt-result',
    name: 'uploadCbtResult',
    meta: {
      title: 'CBT試験合否結果CSVアップロード',
      authRequired: true,
    },
    component: () => import('../pages/pass-fail-result/cbt/index.vue'),
  },
  {
    path: '/upload-result-new-user',
    name: 'uploadResultNewUser',
    meta: {
      title: '新規審査合否結果CSVアップロード',
      authRequired: true,
    },
    component: () => import('../pages/pass-fail-result/new-user/index.vue'),
  },
  {
    path: '/update-result',
    name: 'updateResult',
    meta: {
      title: '更新合否結果反映',
      authRequired: true,
    },
    component: () => import('../pages/pass-fail-result/update-user/index.vue'),
  },
  {
    path: '/upload-result-facility',
    name: 'uploadResultFacility',
    meta: {
      title: '施設認定申請合否結果CSVアップロード',
      authRequired: true,
    },
    component: () => import('../pages/pass-fail-result/facility/index.vue'),
  },
  {
    path: '/import-receipt-user-csv',
    name: 'importReceiptUserCsv',
    meta: {
      title: '書類受領バーコードCSVインポート',
      authRequired: true,
    },
    component: () => import('../pages/document-import/user-cert/index.vue'),
  },
  {
    path: '/import-receipt-facility-csv',
    name: 'importReceiptFacilityCsv',
    meta: {
      title: '施設申請認定書類受領バーコードCSVインポート',
      authRequired: true,
    },
    component: () => import('../pages/document-import/facility-cert/index.vue'),
  },
  {
    path: '/auth/500',
    name: '500Error',
    meta: {
      title: 'Error 500',
      authRequired: true,
    },
    component: () => import('../views/errors/500.vue'),
  },
  {
    path: '/:catchAll(.*)', // すべてのパスにマッチ
    name: 'NotFound',
    meta: {
      title: 'Error 404',
      authRequired: false,
    },
    component: () => import('../views/errors/404-cover.vue'),
  },
];
